import React, { useEffect, useState, useContext } from "react";
import { LisencePlateContext } from "../../../../contexts";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Camera from "./Camera";
import styles from "./WareHouse.module.css";
import axiosClient from "../../../../services/axiosClient";

import { useStoreContext } from "../../../../hooks/useStoreContext";

const cx = classNames.bind(styles);
const WareHouse = ({
  icon,
  name,
  show,
  parentShow,
  onClick,
  indexWareHouse,
  code,
  status,
  groupCode,
  record,
}) => {
  const { plate } = useContext(LisencePlateContext);
  const [camera, setCamera] = useState([]);
  const [check, setCheck] = useState(false);
  const [size, setSize] = useState(1);
  const [pageEnd, setPageEnd] = useState(false);
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  useEffect(() => {
    const getListCameraByCode = async () => {
      if (!pageEnd) {
        const ai_config =
          plate === "all"
            ? {}
            : {
                ai_config: plate === "On" ? 1 : 0,
              };
        const res = await axiosClient.get(
          `/camerainfo/get-list-camera-by-warehouse-code/?page=${size}&size=10`,
          {
            params: {
              status_active: status,
              group_code: groupCode ? groupCode : null,
              ai_service_code: "20230222000000000006",
              warehouse_code: code,
              ...ai_config
            },
          }
        );
        if (res.data.length > 0) {
          let cameraData = res?.data?.map((item) => {
            return {
              ...item,
              CHECK: false,
            };
          });
         
            setCamera((prev) => [...prev, ...cameraData]);
          
        } else {
          setPageEnd(true);
        }
      }
    };
    getListCameraByCode();
  }, [code, name, size, pageEnd, status, groupCode, plate]);

  const onClicks = (data) => {
    onClick(data);
  };

  const handleScrollBar = (e) => {
    if (
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop <
        e.target.clientHeight + 2 &&
      !pageEnd
    ) {
      setSize(size + 1);
    }
  };
  useEffect(() => {
    if (camera.length > 0) {
      const data = [...camera];
      let cameraChose = [];
      dataStore.listCodeCamera.forEach((element) => {
        cameraChose = [...element.data, ...cameraChose];
      });
      // const cameraChose = dataStore.listCodeCamera;
      const cameraData = data?.map((item) => {
        let index = cameraChose?.findIndex(
          (item_1) => item_1?.code === item?.CODE
        );
        if (index >= 0) {
          return {
            ...item,
            CHECK: true,
          };
        } else {
          return {
            ...item,
            CHECK: false,
          };
        }
      });
      setCamera(cameraData);
    }
    // eslint-disable-next-line
  }, [camera.length]);

  useEffect(() => {
    if (dataStore.listCodeCamera.length > 0) {
      let activeWare = dataStore.listCodeCamera.find(
        (item) => item.warehouseCode === code
      );
      // && activeWare.type === 'listCam'
      if (activeWare && camera) {
        let listCamChoose = activeWare.data;
        let listIndex = camera.map((item) => {
          let index = listCamChoose.findIndex((it) => it.code === item.CODE);
          return index;
        });
        let checkFull = listIndex.findIndex((item) => item === -1);
        if (checkFull < 0) {
          setCheck(true);
        } else {
          setCheck(false);
        }
      }
    }
  }, [dataStore.listCodeCamera, code, camera]);
  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(indexWareHouse)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {/* <input
        onChange={(e) => handleChange(e, code)}
        checked={check}
        className={cx("check")}
        type="checkbox"
      /> */}
      {parentShow && show && (
        <div className={cx("warehouse")} onScroll={handleScrollBar}>
          {camera &&
            camera.map((item, index) => (
              <Camera
                check={item?.CHECK}
                key={index}
                status={item.STATUS_ACTIVE}
                name={item.NAME_CAM}
                camID={item.CODE}
                configAi={item.AI_CONFIG}
                setCheck={setCheck}
                prioritized={item.PRIORITIZED}
                wareHouseCode={code}
                index={index}
              />
            ))}
        </div>
      )}
    </div>
  );
};
WareHouse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  parentShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};
export default WareHouse;
